import axios from 'api/api.config';
import { useQuery } from 'react-query';

export const STOCK_MOVEMENT_PICKING = {
  PRINT_DATA: 'PRINT_DATA',
  DETAIL_EXPIRED_DATE: 'DETAIL_EXPIRED_DATE',
};

export function useGetPrintDataPicking(poIds) {
  return useQuery(
    [STOCK_MOVEMENT_PICKING.PRINT_DATA, { poIds }],
    () =>
      axios
        .post(`/api/v1/admin/pre-order/picking/list-approved-po`, {
          pre_order_ids: poIds,
        })
        .then((res) => res.data),
    {
      enabled: !!poIds?.length,
    }
  );
}

export function useGetDetailExpiredDate(poId) {
  return useQuery(
    [STOCK_MOVEMENT_PICKING.DETAIL_EXPIRED_DATE, { poId }],
    () => axios.get(`/api/v1/admin/pre-order/picking/exp-dates/${poId}`).then((res) => res.data),
    {
      enabled: !!poId,
    }
  );
}
